import { Banner } from '@astryxdesign/core/Banner';
import { VStack } from '@astryxdesign/core/Stack';

/** Preview studios take only demo bookings and never send notifications. */
export function PreviewBanner() {
  return (
    <VStack paddingInline={4}>
      <Banner
        status="warning"
        title="Это образец приложения"
        description="Записи здесь демонстрационные: студия их не получит, уведомления не отправляются."
        collapsible={false}
      />
    </VStack>
  );
}
